import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";
import logo from "../assets/logo.svg";
import drawStyles from "../themes/SideBarStyles";
import Menus from "./Menus";
const LeftDrawer = (props) => {
  let { navDrawerOpen, classes, theme, handleChangeNavDrawer } = props;
  const drawerContent = () => (
    <div>
      <div className="bottomBorder ">
        <div
          className={classNames(
            classes.avatarRoot,
            !navDrawerOpen && classes.avatarRootMini
          )}
        >
          <Avatar
            alt="Tmill logo"
            src={logo}
            className={classNames(
              classes.large,
              !navDrawerOpen && classes.small
            )}
          />
          <h2 className="logoName">Railways</h2>
        </div>
      </div>
      <div className="leftBorder">
        <Menus menus={props.menus} navDrawerOpen={navDrawerOpen} />
      </div>
    </div>
  );
  return (
    <div>
      {/* Mobile screen */}
      <Hidden mdUp>
        <Drawer
          variant="temporary"
          anchor={theme.direction === "rtl" ? "right" : "left"}
          open={navDrawerOpen}
          onClose={handleChangeNavDrawer}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: false, // Better open performance on mobile. chan
          }}
        >
          {/* should close drawer modal as well when click on menu */}
          {drawerContent(handleChangeNavDrawer)}
        </Drawer>
      </Hidden>
      {/* Desktop screen */}
      <Hidden smDown>
        <Drawer
          open={navDrawerOpen}
          variant="permanent"
          classes={{
            paper: classNames(
              classes.drawerPaper,
              !navDrawerOpen && classes.drawerPaperClose
            ),
          }}
        >
          {drawerContent()}
        </Drawer>
      </Hidden>
    </div>
  );
};
LeftDrawer.propTypes = {
  navDrawerOpen: PropTypes.bool,
  menus: PropTypes.array,
  username: PropTypes.string,
  classes: PropTypes.object,
  theme: PropTypes.object,
  handleChangeNavDrawer: PropTypes.func,
};
export default withStyles(drawStyles, { withTheme: true })(LeftDrawer);
